/**
 * Splits an array into chunks of a specified size.
 *
 * @param arr The array to split
 * @param size The length of the chunks
 * @returns An array of arrays of the specified size.
 */
export default function chunkArray<T>(arr: T[], size: number): T[][] {
  const arrCopy = [...arr];
  const results: T[][] = [];

  while (arrCopy.length) {
    results.push(arrCopy.splice(0, size));
  }
  return results;
}
